"use client"

import { useState } from 'react'
import useT from '@hooks/useTranslation'

export function ExcerptMini({ text }) {
	const [show, setShow] = useState(false)

	const textToShow = show ? text : text.slice(0, 3) + '...'
	const t = useT('Pokaż')

	if (!text) return null
	return (
		<>
			{textToShow}&nbsp;
			{!show && (
				<button
					onClick={() => setShow(true)}
					style={{ border: 'none', cursor: 'pointer' }}
				>
					{t}
				</button>
			)}
		</>
	)
}